import social from "@/lib/prismicio/prismic-social.json"
import { PrismicSocialJson } from "@jog/shared"
import { useMemo } from "react"

export const useSocial = () => useMemo(() => social as PrismicSocialJson, [])
